module.exports = __webpack_public_path__ + "img/home-img-7.1cf10b68.png";